import React, { useContext, useState } from 'react';
import { DraftEditorStateContext } from '../../context/DraftEditorStateContext';

import { getTableOfContentsFromContentState } from '../../tettra-editor/utilities/tableOfContents';
import editorStateToRawContent from '../../tettra-editor/utilities/editorStateToRawContent';

import TableOfContents from '../page/TableOfContents';

const ExpanderCaret = ({ showTOC }) => (showTOC
    ? (<span className="expand-caret mr1">▼</span>)
    : (<span className="expand-caret mr1">▶</span>));

export default ({ title }) => {
    const [showTOC, setShowTOC] = useState(true);
    const { draftEditorState } = useContext(DraftEditorStateContext);

    if (!draftEditorState) return null;

    const rawContent = editorStateToRawContent(draftEditorState);

    const tableOfContents = getTableOfContentsFromContentState(rawContent);

    if (!tableOfContents || !tableOfContents.length) return null;

    return (
        <div className="page-toc">
            <button className="page-toc-btn" onClick={() => setShowTOC(!showTOC)} type="button">
                <ExpanderCaret showTOC={showTOC} />
                <span className="page-toc-header">Table of contents</span>
            </button>
            {showTOC && <TableOfContents data={tableOfContents} title={title} isDraft />}
        </div>
    );
};
